import React from "react";
import "./mvs.css";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import OurApproach from "./OurApproach";
import EnsureSecurity from "./EnsureSecurity";
import Benefits from "./Benefits";
import CallToAction from "./CallToAction";
import IndustriesServed from "./IndustriesServed";

const MachineVisionSolutions = () => {
  return (
    <div className="mvs-service-wrapper">
      <Particles title="Machine Vision Solutions" />
      <HeroSection />
      <IndustriesServed />
      <OurApproach />
      <EnsureSecurity />
      <Benefits />
      <CallToAction />
    </div>
  );
};

export default MachineVisionSolutions;
